/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ResetPasswordDto } from '../models/reset-password-dto';
import { userChangePassword } from '../fn/user/user-change-password';
import { UserChangePassword$Params } from '../fn/user/user-change-password';
import { userGetPasswordResetRequest } from '../fn/user/user-get-password-reset-request';
import { UserGetPasswordResetRequest$Params } from '../fn/user/user-get-password-reset-request';
import { UserPasswordResetRequestDto } from '../models/user-password-reset-request-dto';
import { userResetPasswordWithLoginOrMail } from '../fn/user/user-reset-password-with-login-or-mail';
import { UserResetPasswordWithLoginOrMail$Params } from '../fn/user/user-reset-password-with-login-or-mail';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userResetPasswordWithLoginOrMail()` */
  static readonly UserResetPasswordWithLoginOrMailPath = '/v1/User/ResetPasswordWithLoginOrMail';

  /**
   * Reset password by login (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER].
   *
   * It will return the matching user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userResetPasswordWithLoginOrMail()` instead.
   *
   * This method doesn't expect any request body.
   */
  userResetPasswordWithLoginOrMail$Response(params?: UserResetPasswordWithLoginOrMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResetPasswordDto>> {
    return userResetPasswordWithLoginOrMail(this.http, this.rootUrl, params, context);
  }

  /**
   * Reset password by login (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER].
   *
   * It will return the matching user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userResetPasswordWithLoginOrMail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userResetPasswordWithLoginOrMail(params?: UserResetPasswordWithLoginOrMail$Params, context?: HttpContext): Observable<ResetPasswordDto> {
    return this.userResetPasswordWithLoginOrMail$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResetPasswordDto>): ResetPasswordDto => r.body)
    );
  }

  /** Path part for operation `userChangePassword()` */
  static readonly UserChangePasswordPath = '/v1/User/ChangePassword';

  /**
   * Change password and update reset request (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER].
   *
   * It will return a message if the password is changed
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userChangePassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userChangePassword$Response(params?: UserChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<ResetPasswordDto>> {
    return userChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * Change password and update reset request (AllowAnonymous) ,   Restricted to [HOSPITAL|INSURER].
   *
   * It will return a message if the password is changed
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userChangePassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  userChangePassword(params?: UserChangePassword$Params, context?: HttpContext): Observable<ResetPasswordDto> {
    return this.userChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResetPasswordDto>): ResetPasswordDto => r.body)
    );
  }

  /** Path part for operation `userGetPasswordResetRequest()` */
  static readonly UserGetPasswordResetRequestPath = '/v1/User/GetPasswordResetRequest';

  /**
   * Get password reset request generated from token (AllowAnonymous) ,   Restricted to [HOSPITAL].
   *
   * It will return the user password reset request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetPasswordResetRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetPasswordResetRequest$Response(params?: UserGetPasswordResetRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPasswordResetRequestDto>> {
    return userGetPasswordResetRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Get password reset request generated from token (AllowAnonymous) ,   Restricted to [HOSPITAL].
   *
   * It will return the user password reset request
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userGetPasswordResetRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGetPasswordResetRequest(params?: UserGetPasswordResetRequest$Params, context?: HttpContext): Observable<UserPasswordResetRequestDto> {
    return this.userGetPasswordResetRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserPasswordResetRequestDto>): UserPasswordResetRequestDto => r.body)
    );
  }

}
